module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAAXNSR0IArs4c6QAAANZJREFUOBFjYBgFtA4BRlIs+P//Pz9QfTIQ8yHp+wRkz2VkZPyIJEYaE2hwERBjA0XoJrEgCwB1EHIRskuRtWKIoxgMVAnyZi+yDiR2HxKbIJMJTQWGzVB5XOJo2hFcdIMRMhSyGIHhqgs0Ixhqjj2QdoCykakDQM5BICYkD9KzFphCLtPMxSAb4ADo+gZsaQkkDlJESB5uEJBBMxejGwzKRdgALnFsasFi6Ol4LlQlcvICZ1mcJuCQQDEYmt/xZQRcLscQRzEYh+XIwlTzEbKho2zyQgAA3dZxK+VeRpYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/Align/layout_ValignMiddle_normal.png
// module id = 321
// module chunks = 0